// extracted by mini-css-extract-plugin
export default {"group":"PaidInvoicesListGroup_group__p4QD1","title":"PaidInvoicesListGroup_title__-lNL+","item":"PaidInvoicesListGroup_item__dPdjf"};